/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Settings_Cancel_DescInputs */

const en_settings_cancel_desc = /** @type {(inputs: Settings_Cancel_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You keep full access until ${i?.date}. Tell us why you're leaving — it helps us improve.`)
};

const id_settings_cancel_desc = /** @type {(inputs: Settings_Cancel_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Akses penuh tetap sampai ${i?.date}. Ceritakan alasannya — ini membantu kami memperbaiki produk.`)
};

/**
* | output |
* | --- |
* | "You keep full access until {date}. Tell us why you're leaving — it helps us improve." |
*
* @param {Settings_Cancel_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_cancel_desc = /** @type {((inputs: Settings_Cancel_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Cancel_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_cancel_desc(inputs)
	return en_settings_cancel_desc(inputs)
});